import { AfterViewChecked, Component, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { ApiService } from 'src/app/api.service';
import { IonCard, IonSpinner, IonCardContent } from "@ionic/angular/standalone";
import { CommonModule } from '@angular/common';

@Component({
  selector: 'ig-embed',
  templateUrl: './instagram-post.component.html',
  styleUrls: ['./instagram-post.component.scss'],
  standalone: true,
  imports: [IonCardContent, IonCard, IonSpinner, CommonModule]
})
export class InstagramPostComponent implements OnChanges, AfterViewChecked {

  @Input() postUrl!: string

  loading = false
  error = ''
  safeHtml: SafeHtml | null = null
  private needsProcess = false

  constructor(
    private api: ApiService,
    private sanitizer: DomSanitizer
  ) { }

  ngOnChanges(changes: SimpleChanges) {
    if (changes['postUrl'] && this.postUrl) {
      this.fetch()
    }
  }

  private async fetch() {
    this.loading = true
    this.error = ''
    this.safeHtml = null

    const igres = await this.api.getInstagramPostData(this.postUrl)
    if (igres.html) {
      this.safeHtml = this.sanitizer.bypassSecurityTrustHtml(igres.html)
      this.needsProcess = true
      this.loading = false
    } else {
      this.error = "Caricamento del post non riuscito..."
        this.loading = false
    }
    
  }

  ngAfterViewChecked() {
    // Ask Instagram’s script to “upgrade” blockquotes/iframes once the HTML is in the DOM
    if (this.needsProcess && (window as any).instgrm?.Embeds?.process) {
      try { (window as any).instgrm.Embeds.process() } catch { }
      this.needsProcess = false
    }
  }

}
